// import { call, takeEvery } from 'redux-saga/effects';

// function* logActions(action) {
//   yield call(console.log, 'hello action from saga:', action);
// }

export default function* rootSaga() {
  // yield takeEvery('*', logActions);
}



// WEBPACK FOOTER //
// ./src/saga.js